import { Form } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  height: 100%;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-bottom: 3rem;
`;

export const Title = styled.b`
  font-size: x-large;
  color: ${({ theme }) => theme.colors?.text.primary};
  text-align: center;
`;

export const SubTitle = styled.b`
  font-size: small;
  color: ${({ theme }) => theme.colors?.text.secondary};
  text-align: center;
`;

export const ContainerSuccess = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;

export const Remember = styled.section`
  display: flex;
  align-items: center;

  width: 100%;

  justify-content: flex-end;
`;

export const Forgot = styled.section`
  display: flex;
  align-items: center;

  width: 100%;

  justify-content: flex-end;
`;

export const A = styled.a`
  color: ${({ theme }) => theme.colors?.text.secondary};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.5rem;
  gap: 0.5rem;

  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

export const ButtomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  width: 100%;
  padding-top: 1rem;
`;

export const P = styled.p`
  text-align: justify;
  color: ${({ theme }) => theme.colors?.text.primary};
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
`;
